import { API_BASE, devSession } from '@platform/dao';
import { HttpClient } from '@platform/dao/HttpClient';
import { AuthDao } from './AuthDao';

/** Транспорт входу: той самий базовий URL і заголовки, що й dao платформи (мова; Dev-користувач — лише коли його задано). */
const http = new HttpClient({
  baseUrl: API_BASE,
  headers: () => ({ 'Accept-Language': devSession.lang, ...(devSession.user ? { 'X-Dev-User': devSession.user } : {}) }),
});

/** Єдиний екземпляр DAO входу й режиму спостерігача. */
export const authDao = new AuthDao(http);
